import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class SecondaryNavService {
  // Menu items is read-only to external components and must be set using the setItems method
  // This is to ensure that the styleClass property is set correctly
  // and to prevent external components from modifying the menu items directly
  private _menuItems: MenuItem[]

  constructor(
    private router: Router
  ) {
    this.menuItems = []
  }

  setActive(routePath: string) {
    const activeIndex = this.menuItems.findIndex(item => item.routerLink === routePath)
    this.menuItems.forEach(item => item.styleClass = '')
    this.menuItems[activeIndex].styleClass = 'active'
  }

  setItems(items: MenuItem[]) {
    items.forEach((item) => {
      const originalCommand = item.command
      item.command = (event) => {
        if (originalCommand) {
          originalCommand(event);
        }
        this.menuItems.forEach((i) => {
          i.styleClass = '';
        });
        item.styleClass = 'active';
      };
    })
    this.menuItems = items;
  }

  public get menuItems(): MenuItem[] {
    return this._menuItems;
  }

  private set menuItems(items: MenuItem[]) {
    this._menuItems = items;
  }
}
